import { useEffect } from 'react'
import Page from 'shared/types/Page'
import loadPages from 'utils/loadPages'
import Store from 'redux/Store'
import hasAnyRole from 'shared/utils/hasAnyRole'
import { roles } from 'consts'
import { setMenuPages } from 'shared/redux/actions'
import getPageByPath from 'shared/utils/getPageByPath'
import { setLastUrl, setViewMode } from 'shared/redux/actions'
import { setFilterValues } from 'redux/actions'

interface useInitProps {
  setPages: Function
  pages: Page[]
  position?: string | boolean | undefined
  menuPages: any
  role: string
  customer?: any
  setViewModeLoaded: Function
}

const useInit = (props: useInitProps) => {
  
  useEffect(() => {

    const customerActive = (props.customer && (props.customer.active === 1)) ? true : false
    const isSuperadmin = hasAnyRole([roles.superAdmin])
    const loadFromServer = isSuperadmin || customerActive

    if (!props.menuPages.length) {
      loadPages({
        role: props.role,
        customer: props.customer,
        loadFromServer
      }).then((pages) => {
        props.setPages(pages)
        Store.dispatch(setMenuPages(pages))

        const page = getPageByPath(window.location.pathname)

        if (page?.roles && page?.roles.length) {
          const viewMode: string = page.roles[0] ?? ''
          Store.dispatch(setViewMode(viewMode))

          let lastUrl = Store.getState()?.lastUrl.lastUrl

          if (lastUrl === null) {
            lastUrl = {}
          }

          lastUrl[viewMode] = window.location.pathname
          Store.dispatch(setLastUrl(lastUrl))
        }
        
        props.setViewModeLoaded(true)
      })
    } else {
      props.setPages(props.menuPages)
    }
    
    // reset filter values
    Store.dispatch(setFilterValues({}))
    
  }, [])
}

export default useInit
